import dynamic from 'next/dynamic';

import AuthCardLayout from 'global/AuthCardLayout';
import QueryProvider from 'global/QueryProvider';

import { useForgotPasswordState } from './store';
import { ForgotPasswordStyle } from './styled';

const EmailForm = dynamic(() => import('./EmailForm'));
const CheckEmailNotify = dynamic(() => import('./CheckEmailNotify'));

function ForgotPassword() {
  const { emailSent } = useForgotPasswordState();

  const Component = emailSent ? CheckEmailNotify : EmailForm;

  return (
    <AuthCardLayout hasShadow={false} wrapperClassName="forgot-password">
      <QueryProvider>
        <ForgotPasswordStyle />
        <Component />
      </QueryProvider>
    </AuthCardLayout>
  );
}

export default ForgotPassword;
